module.exports = ":host {\n  color: #2b7499;\n  cursor: pointer;\n}\n\n:host(:active),\n:host(:hover) {\n  color: #1a475d;\n}\n"